import { jsx as _jsx } from "react/jsx-runtime";
import { get_z3k_object_state, Pump, RelayControl, ThreewayTap, } from 'z3k-config';
import { PumpIndicator } from '../components/icons/pump';
import { RelayIndicator } from '../components/icons/relay';
import { ThreewayTapIndicator } from '../components/icons/threeway-tap';
export function getThreewayTapIconState(state) {
    const fully_open = state?.fully_open ?? false;
    const fully_closed = state?.fully_closed ?? false;
    const direction = state?.direction ?? ThreewayTap.Direction.idle;
    if (fully_open) {
        return {
            fill: '#c4443b',
            fillOpacity: '0.553',
            status: 'Открыт',
        };
    }
    if (fully_closed) {
        return { fill: '#7d9dff', fillOpacity: '0.822', status: 'Закрыт' };
    }
    switch (direction) {
        case ThreewayTap.Direction.close_run:
            return { fill: '#7d9dff', fillOpacity: '0.822', status: 'Закрывается' };
        case ThreewayTap.Direction.open_run:
            return { fill: '#c4443b', fillOpacity: '0.553', status: 'Открывается' };
        default:
            return { fill: '#808080', fillOpacity: '0.327', status: 'В покое' };
    }
}
export function getPumpIconState(state) {
    switch (state?.run) {
        case true:
            return { status: 'Работает' };
        case false:
            return { status: 'Не работает' };
        default:
            return { status: 'Неизвестно' };
    }
}
export function getRelayIconState(state) {
    switch (state?.active) {
        case true:
            return { status: 'Замкнуто' };
        case false:
            return { status: 'Разомкнуто' };
        default:
            return { status: 'Неизвестно' };
    }
}
export function getRelayIndicator(device_id, z3k_config, z3k_state) {
    const relay = RelayControl.get.byId(z3k_config, device_id);
    if (relay) {
        const { id, name } = relay;
        const relay_state = get_z3k_object_state(z3k_state, id);
        const { status } = getRelayIconState(relay_state);
        return {
            status,
            name,
            icon: _jsx(RelayIndicator, { active: relay_state?.active, name: name }, id),
        };
    }
    return null;
}
export function getPumpIndicator(device_id, z3k_config, z3k_state) {
    const pump = Pump.get.byId(z3k_config, device_id);
    if (pump) {
        const { id, name } = pump;
        const pump_state = get_z3k_object_state(z3k_state, id);
        const { status } = getPumpIconState(pump_state);
        return {
            status,
            name,
            icon: (_jsx(PumpIndicator, { active: pump_state?.run ?? false, name: name }, id)),
        };
    }
    return null;
}
export function getThreewayTapIndicator(device_id, z3k_config, z3k_state) {
    const tap = ThreewayTap.get.byId(z3k_config, device_id);
    if (tap) {
        const { id, name } = tap;
        const tap_state = get_z3k_object_state(z3k_state, id);
        const direction = tap_state?.direction ?? ThreewayTap.Direction.idle;
        const active = direction != ThreewayTap.Direction.idle;
        const tap_icon_state = getThreewayTapIconState(tap_state);
        const status = tap_icon_state.status;
        return {
            status,
            name,
            icon: (_jsx(ThreewayTapIndicator, { active: active, name: name, ...tap_icon_state }, id)),
        };
    }
    return null;
}
export function getControlDevice(device_id, z3k_config, z3k_state, options) {
    const relay = getRelayIndicator(device_id, z3k_config, z3k_state);
    const pump = getPumpIndicator(device_id, z3k_config, z3k_state);
    const threeway_tap = getThreewayTapIndicator(device_id, z3k_config, z3k_state);
    if (relay && !options?.hide_relay) {
        return relay;
    }
    if (pump) {
        return pump;
    }
    if (threeway_tap) {
        return threeway_tap;
    }
    return null;
}
